import React from 'react';
import { flow } from 'lodash';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  TextField,
} from '@mui/material';
import { useDispatch } from 'react-redux';

import toaster from '@giro/shared-store/toaster';

import useFetchHook from '@giro-pdv/hooks/useFetch.hook';

import patchApiTerminalsRegistrationsIdService from '@giro/shared-services/pdv/patchApiTerminalsRegistrationsId.service';

const DialogRenameTerminalComponent = ({
  open,
  registration,
  onClose,
  onRenamed,
}: {
  open: boolean;
  registration: { id: any; alias?: string | null } | null;
  onClose: () => void;
  onRenamed: () => void;
}) => {
  const dispatch = useDispatch();

  const showToaster = flow(toaster.action.show, dispatch);

  const renameFetch = useFetchHook(patchApiTerminalsRegistrationsIdService, {
    requestOnMount: false,
  });

  const [alias, setAlias] = React.useState('');

  React.useEffect(() => {
    if (open) setAlias(registration?.alias || '');
  }, [open, registration]);

  const saving = renameFetch.loading;

  const handleConfirm = async () => {
    const trimmed = alias.trim();
    if (!trimmed || saving) return;

    const [success] = await renameFetch.handleFetch(registration?.id, {
      alias: trimmed,
    });

    if (!success) {
      showToaster({
        message: 'Não foi possível renomear o dispositivo.',
        variant: 'error',
      });
      return;
    }

    showToaster({
      message: 'Dispositivo renomeado com sucesso.',
      variant: 'success',
    });
    onRenamed();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Renomear dispositivo</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          size="small"
          label="Nome do dispositivo"
          inputProps={{ maxLength: 255 }}
          value={alias}
          onChange={(ev) => setAlias(ev.target.value)}
          onKeyDown={(ev) => {
            if (ev.key === 'Enter') handleConfirm();
          }}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={saving}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleConfirm}
          disabled={!alias.trim() || saving}
          startIcon={saving ? <CircularProgress size={16} /> : undefined}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogRenameTerminalComponent;
